import { registerPlugin } from '@capacitor/core';
import { NotificationsPlugin } from '@/native/plugins/Notifications/definitions';

const Notifications = registerPlugin<NotificationsPlugin>('Notifications', {
  web: () => import('./web').then((m) => new m.NotificationsWeb()),
});

export * from './definitions';
export { Notifications };
